import React from "react";
import { useWorkspaceTaskGroups } from "@api/taskGroup.api";
import { BaseFilterProps } from "../../lib";
import { SearchableIdListFilter } from "../SearchableIdListFilter/SearchableIdListFilter";

export const TaskGroupFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: taskGroups = [] } = useWorkspaceTaskGroups();

    return (
        <SearchableIdListFilter
            items={taskGroups}
            selectedIds={filters.taskGroupIds}
            onChange={(taskGroupIds) => onChange({ taskGroupIds })}
            name="taskGroup"
        />
    );
};
